'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tagLocal = require('./tag.local.css');

var _tagLocal2 = _interopRequireDefault(_tagLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Tag = function (_React$Component) {
  _inherits(Tag, _React$Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'renderRemoveButton',
    value: function renderRemoveButton() {
      var _this2 = this;

      return _react2.default.createElement('span', {
        onClick: this.props.onRemoveClick,
        onKeyDown: function onKeyDown(e) {
          return e.keyCode === 13 ? _this2.props.onRemoveClick(e) : null;
        },
        className: _tagLocal2.default.closeBtn,
        style: {
          cursor: 'pointer'
        },
        type: 'tagRemoveButton',
        role: 'button',
        tabIndex: 0,
        title: this.props.removeButtonTitle,
        'aria-label': this.props.removeButtonTitle
      }, '\xD7');
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = [_tagLocal2.default.base, this.props.className];
      return _react2.default.createElement('span', {
        className: (0, _classnames2.default)(classes, _tagLocal2.default.tag)
      }, this.props.children, ' ', this.props.removeable ? this.renderRemoveButton() : '');
    }
  }]);

  return Tag;
}(_react2.default.Component);

Tag.defaultProps = {
  removeable: true,
  removeButtonTitle: 'Remove'
};
Tag.propTypes = {
  children: _propTypes2.default.node,

  /**
   * If false, no close button is provided for the tag.
   */
  removeable: _propTypes2.default.bool,

  /**
   * Called when the remove button is clicked. Has to handle the actual removal of the tag.
   */
  onRemoveClick: _propTypes2.default.func,

  /**
   * ClassName will insert styles to override defaults
   */
  className: _propTypes2.default.string,

  /**
   * The title to give a Tag's 'Remove' x button; used for accessibility.
   */
  removeButtonTitle: _propTypes2.default.string
};
exports.default = Tag;